<template>

        <v-select
                prepend-icon="store"
                :items="items"
                :item-text="'name'"
                :item-value="'id'"
                v-model="item"
                :label="$t(label)"
                :loading="loading"
                :error="hasInputErrors('branch')"
                :error-messages="getInputErrors('branch')"
                color="secondary"
                item-color="secondary"
                :rules="isRequired ? required : null"
                :clearable="clearable"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


    import BranchProvider from "../../../../providers/BranchProvider"

    export default {
        name: "BranchCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {
               type: [String, Array]
            },
          label: {type: String, default: 'delivery.stockDaily.labels.branch'},
          clearable: {type: Boolean, default: false},
          isRequired: {type: Boolean, default: true},
        },
        data() {
            return {
                items: [],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
        mounted() {
         this.fetch()
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            },
            fetch(){
               this.loading= true
                BranchProvider.fetchBranch().then(r => {
                    this.items = r.data.fetchBranch
                }).catch(err => console.error(err))
                .finally(()=> this.loading = false)
            }

        }
    }
</script>

<style scoped>

</style>

